/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum HivAnamnesisFormSection {
    HEADER = 'header',
    INSTITUTIONS = 'institutions',
    PATIENT = 'patient',
    TESTING = 'testing',
    TRANSMISSION_ADULT = 'transmissionAdult',
    TRANSMISSION_CHILD = 'transmissionChild',
    TRANSMISSION_OTHER = 'transmissionOther',
    FAMILY = 'family',
    CLINICAL = 'clinical',
}
